<template>
  <div
    v-if="item && item.isShow === 1 && arrContent && arrContent.length > 0"
    class="mode2-box relative"
    :class="[IsMobile ? 'IsMobile' : '', 'showType' + showType]"
  >
    <div
      class="relative new-mode-header"
      :class="titleAlignmentClass"
      v-if="item.topLanguageMap && item.topLanguageMap?.title && showType !== 6"
    >
      <div>
        <div class="title-left">
          <span class="title">{{ item.topLanguageMap?.title }}</span>
        </div>
        <!-- 副标题 -->
        <div class="title_sub">{{ item.topLanguageMap?.subTitle }}</div>
      </div>
    </div>
    <!-- 样式1 样式2 -->
    <!-- {{ arrContent }} -->
    <div :class="IsMobile ? 'mt10' : 'mt20'" v-if="showType === 1 || showType === 2">
      <div class="content" :class="`content_${content_index}`">
        <el-row :gutter="10">
          <template v-for="(item, i) in arrContent">
            <el-col :xs="12" :span="6">
              <div
                class="mode2-item"
                :class="['one', 'two', 'three', 'for'][i % 4]"
                v-exposure="{ eid: item.eid, jump_value: item.jump }"
                :data-id="item.eid"
                @click="handelClick(item, i)"
                :style="{
                  'background-image': `url(${$utils.returnImgUrl(
                    $utils.lang_data(lang, item, 'langInfoObj')?.background
                  )})`,
                }"
              >
                <div class="mode2-content">
                  <div class="h2">{{ $utils.lang_data(lang, item, "langInfoObj")?.title }}</div>
                  <div class="desc" v-html="$utils.lang_data(lang, item, 'langInfoObj')?.desc"></div>
                </div>
                <img
                  v-if="redDotMap[item.uid] && redDotMap[item.uid].src"
                  class="content-item-tag"
                  :src="redDotMap[item.uid].src"
                  alt=""
                />
                <img
                  class="mode2-thumb"
                  v-if="$utils.lang_data(lang, item, 'langInfoObj')?.img"
                  :src="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.img)"
                  alt=""
                />
                <!-- <div
                  class="mode2-snow"
                >
                </div> -->
              </div>
            </el-col>
          </template>
        </el-row>
      </div>
    </div>
    <!-- 样式3 -->
    <div :class="IsMobile ? 'mt10' : 'mt20'" v-if="showType === 3">
      <div class="content_style3" :class="`content_${content_index}`">
        <template v-for="(item, i) in arrContent">
          <div
            class="mode_item_style3"
            :class="{ 'mr-0': (i + 1) % 6 === 0 }"
            v-exposure="{ eid: item.eid, jump_value: item.jump }"
            :data-id="item.eid"
            @click="handelClick(item, i)"
          >
            <div class="mode_content_style3">
              <div class="h2 ellipsis">{{ $utils.lang_data(lang, item, "langInfoObj")?.title }}</div>
              <div
                class="desc"
                v-html="$utils.lang_data(lang, item, 'langInfoObj')?.desc"
                onmouseover="this.classList.add('expanded')"
                onmouseout="this.classList.remove('expanded')"
              ></div>
            </div>
            <img
              v-if="redDotMap[item.uid] && redDotMap[item.uid].src"
              class="content-item-tag"
              :src="redDotMap[item.uid].src"
              alt=""
            />
            <img
              class="img_style3"
              v-if="$utils.lang_data(lang, item, 'langInfoObj')?.background"
              :src="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.background)"
              alt=""
            />
            <!-- <div
              class="mode2-snow"
            >
            </div> -->
          </div>
        </template>
      </div>
    </div>

    <!-- 样式4 -->
    <div :class="IsMobile ? 'mt10' : 'mt20'" v-if="showType === 4">
      <div class="content_style4" :class="`content_${content_index}`">
        <el-row :gutter="10">
          <template v-for="(item, i) in arrContent">
            <el-col
              :span="getSpan(i)"
              v-if="
                $utils.lang_data(lang, item, 'langInfoObj')?.title ||
                $utils.lang_data(lang, item, 'langInfoObj')?.desc ||
                $utils.lang_data(lang, item, 'langInfoObj')?.background
              "
            >
              <div
                class="mode_item_style4"
                v-exposure="{ eid: item.eid, jump_value: item.jump }"
                :data-id="item.eid"
                @click="handelClick(item, i)"
              >
                <div class="mode_content_style4">
                  <div class="h2 ellipsis">{{ $utils.lang_data(lang, item, "langInfoObj")?.title }}</div>
                  <div
                    class="desc"
                    v-html="$utils.lang_data(lang, item, 'langInfoObj')?.desc"
                    onmouseover="this.classList.add('expanded')"
                    onmouseout="this.classList.remove('expanded')"
                  ></div>
                </div>
                <img
                  v-if="redDotMap[item.uid] && redDotMap[item.uid].src"
                  class="content-item-tag"
                  :src="redDotMap[item.uid].src"
                  alt=""
                />
                <img
                  class="img_style4"
                  v-if="$utils.lang_data(lang, item, 'langInfoObj')?.background"
                  :src="$utils.returnImgUrl($utils.lang_data(lang, item, 'langInfoObj')?.background)"
                  alt=""
                />
                <!-- <div
                  class="mode2-snow"
                >
                </div> -->
              </div>
            </el-col>
          </template>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import mode2 from "@/lobby_common/mixins_views/homeModule/mode2.js";
export default {
  mixins: [mode2],
  methods: {
    formatHtml(content) {
      if (!content) return "";
      const divElement = document.createElement("div");
      divElement.innerHTML = content;
      return divElement.innerText;
    },
  },
};
</script>
<style lang="scss" scoped>
.mode2-item {
  position: relative;
  padding: 0 10px;
  height: 138px;
  display: flex;
  border-radius: 5px;
  // background: #000;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  // overflow: hidden;
  cursor: pointer;
  border-radius: var(--radius-400);
  @media (max-width: 768px) {
    border-radius: var(--radius-401);
    padding: 0 4px;
    height: 110px;
    margin-bottom: 5px;
  }
  .mode2-content {
    flex: 1;
    height: 100%;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media (max-width: 768px) {
      padding: 10px 0;
      width: calc(100% - 60px);
    }
    .h2 {
      font-size: 16px;
      color: var(--font-color-200);
      @media (max-width: 768px) {
        font-size: 12px;
        padding: 5px 0px;
      }
    }
    .desc {
      padding-top: 10px;
      font-size: 14px;
      color: var(--font-color-900);
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      line-height: 1.3;
      ::v-deep p {
        margin: 0 !important;
      }
      @media (max-width: 768px) {
        font-size: 9px;
        -webkit-line-clamp: 2;
      }
    }
  }
  // .mode2-snow{
  //   display: none;
  //   position: absolute;
  //   left: 0;
  //   top: -13px;
  //   width: 100%;
  //   height: 35px;
  //   background-image: url('~@/lobby_common/assets/activity/Snow.png');
  //   background-size: contain;
  //   @media (max-width: 768px) {
  //     top: -7px;
  //     height: 20px;
  //   }
  // }
  .mode2-thumb {
    width: 80px;
    height: auto;
    @media (max-width: 768px) {
      width: 60px;
    }
    // background: #ccc;
  }
}
.mode2-box {
  &.IsMobile {
    padding: 0 10px;
  }
  &.showType1 {
    .mode2-item {
      position: relative;
      padding: 0 10px 0 0;
      height: 140px;
      flex-direction: row-reverse;
      background-size: 100% 100%;
      @media (max-width: 768px) {
        height: 92px;
      }
      .mode2-thumb {
        padding: 0 10px;
        // height: 100%;
        border-radius: var(--radius-400) 0 0 var(--radius-400);
      }
      .mode2-content {
        .desc {
          color: var(--font-color-900);
          padding-top: 5px;
          -webkit-line-clamp: 2;
        }
        @media (max-width: 768px) {
          padding: 5px 0;
          .desc {
            .h2 {
              line-height: 1.4;
            }
            padding-top: 0;
          }
        }
      }
      @media (max-width: 768px) {
        height: 80px;
        -webkit-line-clamp: 2;
        .mode2-thumb {
          width: 53px;
          border-radius: var(--radius-401) 0 0 var(--radius-401);
        }
      }
    }
    .one {
      background-image: linear-gradient(0deg, #322d24 0%, #4a462c 100%);
      // border: 1px solid #ccb663;
    }
    .two {
      background-image: linear-gradient(0deg, #152846 0%, #224474 100%);
      // border: 1px solid #6479f4;
    }
    .three {
      background-image: linear-gradient(0deg, #381c47 0%, #602c7a 100%);
      // border: 1px solid #b751f1;
    }
    .for {
      background-image: linear-gradient(0deg, #1e3e1e 0%, #306f27 100%);
      // border: 1px solid #1fbe3a;
    }
    // .mode2-snow{
    //   display: block;
    // }
  }
  &.showType2 {
    margin-top: 10px;
    .one {
      background: radial-gradient(100% 75% at 50% -10%, #0a62d3 0, rgba(10, 98, 211, 0.11) 70%, transparent 100%),
        #111923;
    }
    .two {
      background: radial-gradient(100% 75% at 50% -10%, #229413 0, rgba(34, 148, 19, 0.11) 70%, transparent 100%),
        #111923;
    }
    .three {
      background: radial-gradient(100% 75% at 50% -10%, #d3b30f 0, rgba(211, 179, 15, 0.11) 70%, transparent 100%),
        #111923;
    }
    .for {
      background: radial-gradient(100% 75% at 50% -10%, #ff0049 0, rgba(255, 0, 73, 0.11) 70%, transparent 100%),
        #111923;
    }
    .mode2-item {
      margin-bottom: 10px;
    }
  }
}
.content_style3 {
  width: 100%;
  overflow: hidden;
  padding-bottom: 30px;
  .mode_item_style3 {
    width: 15%;
    margin-right: 2%;
    float: left;
    position: relative;
    margin-bottom: 10px;
    -webkit-overflow-scrolling: touch; /* ✅ 移动端平滑滑动 */
    scrollbar-width: thin; /* ✅ Firefox 细滚动条 */
    /* ✅ 滚动条样式美化（仅限 Chrome/Safari） */
    &::-webkit-scrollbar {
      height: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
    }
    @media (max-width: 768px) {
      margin-bottom: 0px;
    }
    &.mr-0 {
      margin-right: 0 !important;
    }
    &:nth-child(2n) {
      transform: translateY(30px);
    }
    .mode_content_style3 {
      position: absolute;
      left: 0px;
      bottom: 44px;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      @media (max-width: 768px) {
        bottom: 23px;
        padding: 0 5px;
      }
      .h2 {
        font-size: 28px;
        color: var(--font-color-200);
        @media (max-width: 768px) {
          font-size: 18px;
        }
      }
      .desc {
        padding-top: 2px;
        font-size: 16px;
        color: var(--font-color-200);
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 1.3;
        ::v-deep p {
          margin: 0 !important;
        }
        @media (max-width: 768px) {
          font-size: 12px;
          -webkit-line-clamp: 2;
        }
        &.expanded {
          display: block;
          white-space: normal;
        }
      }
    }
    .img_style3 {
      border-radius: var(--radius-300);
      width: 100%;
    }
  }
}
.IsMobile {
  .content_style3 {
    display: flex;
    overflow-x: auto;
    .mode_item_style3 {
      width: 100px;
      margin-right: 10px;
      flex-shrink: 0;
      &.mr-0 {
        margin-right: 10px !important;
      }
      &:nth-child(2n) {
        transform: translateY(20px);
      }
      &:nth-last-child(1) {
        margin-right: 0px;
      }
    }
  }
}
.content_style4 {
  .mode_item_style4 {
    margin-bottom: 10px;
    position: relative;
    // overflow: hidden;
    border-radius: 8px;
    .mode_content_style4 {
      position: absolute;
      left: 0px;
      bottom: 16px;
      width: 100%;
      padding: 0 15px;
      box-sizing: border-box;
      @media (max-width: 768px) {
        bottom: 8px;
        padding: 0 5px;
      }
      .h2 {
        font-size: 28px;
        color: var(--font-color-200);
        @media (max-width: 768px) {
          font-size: 18px;
        }
      }
      .desc {
        padding-top: 2px;
        font-size: 16px;
        color: var(--font-color-200);
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 1.3;
        ::v-deep p {
          margin: 0 !important;
        }
        @media (max-width: 768px) {
          font-size: 12px;
          -webkit-line-clamp: 2;
        }
        &.expanded {
          display: block;
          white-space: normal;
        }
      }
    }
    .img_style4 {
      width: 100%;
      // transition: transform ease-in-out 0.5s;
      //  &:hover {
      //   transform: scale(1.1);
      //   @media (max-width: 768px) {
      //     transform: unset;
      //   }
      // }
    }
  }
}

.showType1,
.showType2 {
  .content-item-tag {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
  }
}
.showType3 {
  .content_style3 {
    padding-top: 10px;
  }
  .content-item-tag {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
  }
}
.showType4 {
  .content-item-tag {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
  }
}
</style>
